module.exports = require('./helpers/bundle-url').getBundleURL('9iXDo') + "IMG_0011.f213884d.png" + "?" + Date.now();